import {
    HelpCircle,
    MessageCircle,
    Plus,
    Sparkles,
    Users,
    type LucideIcon,
} from "lucide-react";

export type OnboardingItemId =
    | "help"
    | "session"
    | "invite"
    | "consult"
    | "chat";

export interface OnboardingChecklistItem {
    id: OnboardingItemId;
    label: string;
    icon: LucideIcon;
    /** Optional items still show + can be completed, but don't count toward
     * progress or the "you're all set" state. */
    optional?: boolean;
    /** The item is shown but LOCKED (not actionable) until ANY of these items is
     * done — e.g. generate a consultation needs a session; chat needs a
     * consultation. Empty/undefined = always available. */
    requiresAny?: OnboardingItemId[];
    /** Short reason shown on a locked row, e.g. "After a consultation". */
    lockedHint?: string;
}

// AIDEV-NOTE: "Add a session" collapses upload + live-call into one item — done
// by ANY method (media/transcript upload OR a live call). It links to the
// top-level record/upload/invite hub (/invite).
export const ITEMS: ReadonlyArray<OnboardingChecklistItem> = [
    {
        id: "help",
        label: "Visit the help center",
        icon: HelpCircle,
    },
    {
        id: "session",
        label: "Add a session",
        icon: Plus,
    },
    {
        id: "invite",
        label: "Invite your first client",
        icon: Users,
    },
    {
        id: "consult",
        label: "Generate a consultation",
        icon: Sparkles,
        requiresAny: ["session"],
        lockedHint: "After you add a session",
    },
    {
        id: "chat",
        label: "Chat with the consultant",
        icon: MessageCircle,
        requiresAny: ["consult"],
        lockedHint: "After a consultation",
    },
];
